export const NATTER_EXPLAINER_VIDEO =
  window._env_?.VITE_APP_NATTER_EXPLAINER_VIDEO_URL ??
  'https://asset.app.natter.co/attachments/Open_Natter_Promo_v3.mp4';

export const NATTER_EXPLAINER_VIDEO_CAPTIONS =
  window._env_?.VITE_APP_NATTER_EXPLAINER_VIDEO_CAPTIONS_URL ??
  'https://asset.app.natter.co/attachments/Open_Natter_Promo_v3.vtt';
